<template>
  <div>
    <h3 v-if="heading" class="font-bold text-white text-xl">{{ heading }}</h3>
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false });

type Props = {
  heading?: string;
};

defineProps<Props>();
</script>
